<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Indemnizaciones</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>
            <b-col sm="2">
              <b-form-group
                :label="crearLabel('Fecha Programada de Pago', 'fecpago', 'datosFormulario')"
                label-for="fecpago">
                <b-form-select 
                  :options="valFechas"  
                  v-model="datosFormulario.fecpago"
                  :disabled="campoBloqueado('fecpago', 'datosFormulario')"
                >
                </b-form-select>
                
                <span class="error-validacion-campo">
                  {{ mensajeValidacionCampo.fecpago }}
                </span>
              </b-form-group>
            </b-col>  
            <b-col sm="2">
              <b-form-group 
                :label="crearLabel('Código Asegurado', 'codasegurado', 'datosFormulario')"
                label-for="codasegurado">
                <b-form-input
                  id="codasegurado"
                  type="text"
                  placeholder=""
                  v-model="datosFormulario.codasegurado"
                  :disabled="campoBloqueado('codasegurado', 'datosFormulario')"
                  @change="buscarAsegurado">
                </b-form-input>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.codasegurado }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group 
                :label="crearLabel('Asegurado', 'desasegurado', 'datosFormulario')"
                label-for="desasegurado">
                <b-form-input
                  id="desasegurado"
                  type="text"
                  placeholder=""
                  v-model="datosFormulario.desasegurado"
                  :disabled="true">
                </b-form-input>
              
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
            </b-col>  
            <b-col sm="2">
              <b-form-group 
                :label="crearLabel('Código Beneficiario', 'codbeneficiario', 'datosFormulario')"
                label-for="codbeneficiario">
                <b-form-input
                  id="codbeneficiario"
                  type="text"
                  placeholder=""
                  v-model="datosFormulario.codbeneficiario"
                  :disabled="campoBloqueado('codbeneficiario', 'datosFormulario')"
                  @change="buscarBeneficiario">
                </b-form-input>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.codbeneficiario }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group 
                :label="crearLabel('Beneficiario', 'desbeneficiario', 'datosFormulario')"
                label-for="desbeneficiario">
                <b-form-input
                  id="desbeneficiario"
                  type="text"
                  placeholder=""
                  v-model="datosFormulario.desbeneficiario"
                  :disabled="true">
                </b-form-input>
              
              </b-form-group>
            </b-col>
          </b-row>

          <div slot="footer">
            <div class="form-actions">
              <el-row>
                <el-col>
                  <b-button variant="primary" @click="buscar">
                    <i class="fa fa-search"></i> Consultar
                  </b-button>
                  <b-button variant="primary" @click="pre_insertar">
                    <i class="fa fa-eraser"></i> Limpiar
                  </b-button>
                  <b-button variant="primary" @click="descargarExcel">
                    <i class="fa fa-file-excel-o"></i> Exportar
                  </b-button>
                  
                  <b-button variant="success" @click="fnc_indemnizar()" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-save"></i> Indemnizar
                  </b-button>
                  <b-button variant="danger" @click="fnc_quitarvb()" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-save"></i> Quitar V°B°
                  </b-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Indemnizaciones - Casos que se pueden pagar</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable1"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @selection-change="handleSelectionChange">
                >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    sortable="custom"
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  >
                  
                  <template slot-scope="scope">
                    <div v-if="title.prop == 'BENEFICIARIO'">  
                        <el-button type="text" v-if="scope.row.BENEFICIARIOS > 1" @click="detalleBeneficiarios(scope.row.SINIESTRO)">Beneficiarios ({{scope.row.BENEFICIARIOS}})</el-button>   
                        <p v-else >{{scope.row.BENEFICIARIO}}</p>
                    </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
                  </template>
                  
                  </el-table-column>
                  <el-table-column type="selection" width="35" reserve-selection>
                  </el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Indemnizaciones - Casos que no se pueden pagar</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable2"
                  :data="data2"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @selection-change="handleSelectionChange2"
                  @select="SelectionChange2"
                  @select-all="selectAll">
                
                  <el-table-column
                    v-for="title in titles2"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    sortable="custom"
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  >
                  <template slot-scope="scope">
                    <div v-if="title.prop == 'BENEFICIARIO'">  
                        <el-button type="text" v-if="scope.row.BENEFICIARIOS > 1" @click="detalleBeneficiarios(scope.row.SINIESTRO)">Beneficiarios ({{scope.row.BENEFICIARIOS}})</el-button>   
                        <p v-else >{{scope.row.BENEFICIARIO}}</p>
                    </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
                  </template>

                   </el-table-column>
                      <el-table-column type="selection" width="35" reserve-selection>
                   </el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- Quitar V°B°-->
    <b-modal
      title="Quitar V°B°"
      cancel-title="Cancelar"
      ok-title="Quitar V°B°"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalRechazar"
      @ok="rechazar"
      @cancel="modalRechazar = false"
    >
      Todos los siniestros seleccionados seran devueltos a la pantalla de Validacion Gerente area.
    </b-modal>

    <!-- Indemnizar-->
    <b-modal
      title="Indemnizar"
      cancel-title="Cancelar"
      ok-title="Continuar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalIndemnizar"
      @ok="indemnizar"
      @cancel="modalIndemnizar = false"
    >
      Usted indemnizará {{ this.multipleSelection.length }} casos con fecha {{ this.datosFormulario.fecpago }}, ¿desea continuar?
    </b-modal>

  
    <!-- Detalle Beneficiarios -->
    <b-modal
      size="lg"
      ok-only
      title="Beneficiarios"
      cancel-title="Cancelar"
      ok-title="Cerrar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalBeneficiarios"
      @ok="modalBeneficiarios = false"
      @cancel="modalBeneficiarios = false"
    >
      <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable3"
                  :data="dataBeneficiarios"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                >
                  <el-table-column
                    v-for="title in titlesBeneficiarios"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
    </b-modal>

  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiIndemniza from "@/components/services/apiIndemniza";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import download from "downloadjs";
import Multiselect from "vue-multiselect";

import XLSX from "xlsx";

export default {
  name: "Indemnizaciones",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch,
  },
  data: function () {
    return {
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715",
      },

      data: [],
      data2: [],
      dataBeneficiarios: [],
      nombreexcel: "Indemnizaciones",
      titles: [
        {
          prop: "EJECUTIVO",
          label: "Ejecutivo",
          align: "left",
          minwidth: "120",
        },
        {
          prop: "SINIESTRO",
          label: "N° de Siniestro",
          align: "left",
          minwidth: "150",
        },
        {
          prop: "ASEGURADO",
          label: "Razón social Asegurado",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "BENEFICIARIO",
          label: "Razón social Beneficiario",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "DEUDOR",
          label: "Razón social Deudor",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "MONEDA",
          label: "Moneda",
          align: "left",
          minwidth: "120",
        },
        {
          prop: "MONTO",
          label: "Monto a Indemnizar",
          align: "right",
          minwidth: "160",
        },
      ],
      titles2: [
        {
          prop: "EJECUTIVO",
          label: "Ejecutivo",
          align: "left",
          minwidth: "120",
        },
        {
          prop: "SINIESTRO",
          label: "N° de Siniestro",
          align: "left",
          minwidth: "150",
        },
        {
          prop: "ASEGURADO",
          label: "Razón social Asegurado",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "BENEFICIARIO",
          label: "Razón social Beneficiario",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "DEUDOR",
          label: "Razón social Deudor",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "MONEDA",
          label: "Moneda",
          align: "left",
          minwidth: "120",
        },
        {
          prop: "MONTO",
          label: "Monto a Indemnizar",
          align: "right",
          minwidth: "160",
        },
        {
          prop: "ERRORES",
          label: "Motivo",
          align: "left",
          minwidth: "250",
        },
      ],
      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (prop === 'Fecha Est. Config'){
                let elDate = new Date(row["Fecha Est. Config"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
            })
            
          }
        }
      ],

      titlesBeneficiarios: [
        {
          prop: "SBECODBENEF",
          label: "Razón social Beneficiario",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "STAMONEDA",
          label: "Moneda",
          align: "left",
          minwidth: "150",
        },
        {
          prop: "SBEMONTO",
          label: "Monto a Indemnizar",
          align: "right",
          minwidth: "160",
        }
      ],

      datosFormulario: {
        fecpago: "",
        codasegurado: "",
        codbeneficiario: ""
      },

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      valFechas: [],
      
      multipleSelection: [],
      multipleSelection2: [],
      seleccionados:[],
      v_seleccionablesAB:[],

      modalRechazar: false,
      modalIndemnizar: false,
      modalBeneficiarios: false,
      
      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 200,
        rowKey: "SINIESTRO"
      },
    };
  },
  components: {
    Datepicker,
    Multiselect,
  },
  methods: {
    customButtonsForRow(row) {
          var botones = new Array();
          
          if (row.INFORME)
          {
            var obj = new Object();
            obj.tooltip = "Informe Liquidación";
            obj.id = 1;
            obj.name="";
            obj.icon = "fa fa-file-pdf-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                window.open(row.INFORME, '_blank');
            }
            botones.push(obj);
          }

          if (row.CORREO)
          {
            var obj = new Object();
            obj.tooltip = "Correo";
            obj.id = 2;
            obj.name="";
            obj.icon = "fa fa-envelope-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                window.open(row.CORREO, '_self');
            }
            botones.push(obj);
          }
          
          return botones;

    },

    getDate(date) {
      let elDate = new Date(date)
      return elDate.getDate() + '/' + (elDate.getMonth() + 1) + '/' + elDate.getFullYear();   
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.refTable1.$children[0].toggleRowSelection(row);
        });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    handleSelectionChange2(val) {
       this.multipleSelection2 = val;
    },

    SelectionChange2(selection, row) {
    console.log(row["ERRORES"].indexOf('No tiene Validación de Gerente'));

        if (row["ERRORES"].indexOf('No tiene Validación de Gerente') > 0) {
          this.$refs.refTable2.$children[0].toggleRowSelection(row, false);
          this.crearNotificacion("Quitar V°B°", "No se puede seleccionar, al menos un caso sin validación.","error");
          return false;
        };    
    },

    selectAll(rows){

      console.log(rows);
       
      // let v_seleccionables = rows.filter(function (el) { if (el.ERRORES != 'No tiene Validación de Gerente')  return el; })
      
      let v_seleccionablesAB = rows.filter(function (el) { if (el.ERRORES.indexOf('No tiene Validación de Gerente') > 0)  return el; })

      // if (this.seleccionados.length<=0 ){ 
        
      //   this.seleccionados = v_seleccionables;
      //   v_seleccionables.forEach(row => {
      //     this.$refs.refTable2.$children[0].toggleRowSelection(row, false);
      //   })

      // } else {
      //   this.$refs.refTable2.$children[0].clearSelection();
      //   this.seleccionados=[]; 
      // }

      if (this.v_seleccionablesAB.length<=0 ){ 
        
        this.v_seleccionablesAB = v_seleccionablesAB;
        v_seleccionablesAB.forEach(row => {
          this.$refs.refTable2.$children[0].toggleRowSelection(row, false);

        })

      } else {
        this.$refs.refTable2.$children[0].clearSelection();
        this.v_seleccionablesAB=[]; 
      }
     
      
    },



    



    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },

    cambiarFechas() {
      if (this.datosFormulario.selected == "A") {
        this.mostrarFechas = false;
      } else {
        this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
      n = String(n).replace(/\D/g, "");
      return n === "" ? n : Number(n).toLocaleString();
    },

    totales(param) {
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }

        const values = data.map((item) => Number(item[column.property]));

        if (!values.every((value) => isNaN(value))) {
          sums[index] = this.$numeral(
            values.reduce((prev, curr) => {
              const value = Number(curr);

              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          ).format();
          /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },

    exportarExcel() {
      this.$nextTick(function () {
        var tabla = document.getElementById("tableExcel");
        var data = XLSX.utils.table_to_sheet(tabla);
        const workbook = XLSX.utils.book_new();
        const filename = "Export";
        XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      });
    },

    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.data2 = [];
      //this.multipleSelection = [];
      this.value = null;
      this.datosFormulario.desasegurado = "";
      this.datosFormulario.desbeneficiario = "";

      return apiIndemniza
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          
          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == "s") {
            this.tieneAcceso = true;
          } else {
            this.tieneAcceso = false;
          }

          var lista_data = response.data.res;
          for (var i = 0; i < lista_data.length; i++) {
            this.datosFormulario.fecpago = this.convierteFecha(lista_data[i]["fecpago"]);
            this.datosFormulario.codasegurado = lista_data[i]["codasegurado"]=='0'? '' : lista_data[i]["codasegurado"];
            this.datosFormulario.codbeneficiario = lista_data[i]["codbeneficiario"]=='0'? '' : lista_data[i]["codbeneficiario"];
          }
          
          //Carga lista de ejecutivos
          var tiposFecha = new Array();
          var lista_tipos_fecha = response.data.fechas;
          for(var i = 0; i < lista_tipos_fecha.length; i++){
              var obj = new Object();
              obj.value = this.convierteFecha(lista_tipos_fecha[i]["snpfecha"]);
              obj.text = this.convierteFecha(lista_tipos_fecha[i]["snpfecha"]);
              tiposFecha.push(obj);
          }
          this.valFechas = tiposFecha;
          
          this.datosFormularioEstado = response.data.festado;
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();
      this.data = [];
      this.data2 = [];
      return apiIndemniza
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.fecpago,
          this.datosFormulario.codasegurado == ''? '0' : this.datosFormulario.codasegurado, 
          this.datosFormulario.codbeneficiario == ''? '0' : this.datosFormulario.codbeneficiario 
        )
        .then((response) => {
          
          this.data = response.data.res1;
          this.data2 = response.data.res2;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          if (this.data != null) {
            this.exportar = true;
          } else {
            this.exportar = false;
          }
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if ((column.property == "Fecha Est. Config" || column.property == "Fecha Recep. Inf. Liq." || 
           column.property == "Fecha Pago Nómina") 
          && row[column.property]) {
        return this.configurarFechaLat(
          this.convierteFecha(row[column.property])
        );
      } else if ((column.property == "MONTO") && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else {
        return row[column.property];
      }
    },

    descargarExcel: function () {
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 width=698 style='width:526pt;" +
        xl689618 +
        "'>Indemnizaciones para el " + this.datosFormulario.fecpago + "</td>\n";
      cuerpo += "</tr>\n";

      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 style='border-right:.5pt solid black;" +
        xl689618 +
        "' >Casos que se pueden pagar</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      for (var key in this.data) {
        if(this.data[key]["EJECUTIVO"] == undefined){
          this.data[key]["EJECUTIVO"] = "";
        }
        if(this.data[key]["SINIESTRO"] == undefined){
          this.data[key]["SINIESTRO"] = "";
        }
        if(this.data[key]["ASEGURADO"] == undefined){
          this.data[key]["ASEGURADO"] = "";
        }
        if(this.data[key]["BENEFICIARIO"] == undefined){
          this.data[key]["BENEFICIARIO"] = "";
        }
        if(this.data[key]["DEUDOR"] == undefined){
          this.data[key]["DEUDOR"] = "";
        }
        if(this.data[key]["MONEDA"] == undefined){
          this.data[key]["MONEDA"] = "";
        }
        if(this.data[key]["MONTO"] == undefined){
          this.data[key]["MONTO"] = "";
        }
        
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["EJECUTIVO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SINIESTRO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ASEGURADO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["BENEFICIARIO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["DEUDOR"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["MONEDA"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["MONTO"]).format("0,0.00") + "</td>\n";
        cuerpo += "</tr>\n";
      }



      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 style='border-right:.5pt solid black;" +
        xl689618 +
        "' >Casos que no se pueden pagar</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      for (var key in this.data2) {
        if(this.data2[key]["EJECUTIVO"] == undefined){
          this.data2[key]["EJECUTIVO"] = "";
        }
        if(this.data2[key]["SINIESTRO"] == undefined){
          this.data2[key]["SINIESTRO"] = "";
        }
        if(this.data2[key]["ASEGURADO"] == undefined){
          this.data2[key]["ASEGURADO"] = "";
        }
        if(this.data2[key]["BENEFICIARIO"] == undefined){
          this.data2[key]["BENEFICIARIO"] = "";
        }
        if(this.data2[key]["DEUDOR"] == undefined){
          this.data2[key]["DEUDOR"] = "";
        }
        if(this.data2[key]["MONEDA"] == undefined){
          this.data2[key]["MONEDA"] = "";
        }
        if(this.data2[key]["MONTO"] == undefined){
          this.data2[key]["MONTO"] = "";
        }
        if(this.data2[key]["ERRORES"] == undefined){
          this.data2[key]["ERRORES"] = "";
        }
        
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["EJECUTIVO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["SINIESTRO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["ASEGURADO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["BENEFICIARIO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["DEUDOR"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["MONEDA"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data2[key]["MONTO"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["ERRORES"] + "</td>\n";
        cuerpo += "</tr>\n";
      }

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export: async function (data, filename) {
      if (typeof this.beforeFinish === "function") await this.beforeFinish();
      download(data, filename, "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada) {
      if (fechaEntrada != undefined && fechaEntrada.length != 0) {
        var fecha = new Date(fechaEntrada);

        var dia = ("0" + fecha.getUTCDate()).slice(-2);
        var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
        var año = fecha.getUTCFullYear();

        fecha = dia + "-" + mes + "-" + año;

        return fecha;
      } else {
        return fechaEntrada;
      }
    },
    
    buscarAsegurado(){
      this.$Progress.start();
      return apiIndemniza
        .nombre_asegurado(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.codasegurado 
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          if (response.data.res.length > 0) {
            this.datosFormulario.desasegurado = response.data.res[0].nombre_asegurado;
          } else {
            this.datosFormulario.codasegurado = '';
            this.datosFormulario.desasegurado = '';
          }
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscarBeneficiario(){
      this.$Progress.start();
      return apiIndemniza
        .nombre_beneficiario(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.codbeneficiario 
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          if (response.data.res.length > 0) {
            this.datosFormulario.desbeneficiario = response.data.res[0].nombre_beneficiario;
          } else {
            this.datosFormulario.codbeneficiario = '';
            this.datosFormulario.desbeneficiario = '';
          }
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    rechazar(){
      this.$Progress.start();

      /* solo los marcados y filtrados */
      /* Indemnizaciones - Casos que se pueden pagar */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.SINIESTRO);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["SINIESTRO"])){
            marcados.push(this.multipleSelection[index]);
          }
      }

      /* solo los marcados y filtrados */ 
      /* Indemnizaciones - Casos que no se pueden pagar */
      var filtrados2 = this.$refs.refTable2.tableData;
      const names2 = filtrados2.map(el => el.SINIESTRO);
      var marcados2 = new Array();

      for (var index = 0; index < this.multipleSelection2.length; ++index) {
          if (names2.includes(this.multipleSelection2[index]["SINIESTRO"])){
            marcados2.push(this.multipleSelection2[index]);
          }
      }

      var siniestrosMarcados = "";
      var index = 0;

      for (index = 0; index < marcados.length; ++index) {
        siniestrosMarcados += marcados[index]["SINIESTRO"] + ',';
      }

      for (index = 0; index < marcados2.length; ++index) {
        siniestrosMarcados += marcados2[index]["SINIESTRO"] + ',';
      }
      
      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiIndemniza
          .rechazar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestrosMarcados
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                "Quitar V°B°",
                "Se han devuelto todos los siniestros seleccionados.",
                "success"
              );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
    },

    fnc_indemnizar(){
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.SINIESTRO);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["SINIESTRO"])){
            marcados.push(this.multipleSelection[index]);
          }
      }

      /* solo los marcados y filtrados */ 
      /* Indemnizaciones - Casos que no se pueden pagar */
      var filtrados2 = this.$refs.refTable2.tableData;
      const names2 = filtrados2.map(el => el.SINIESTRO);
      var marcados2 = new Array();

      for (var index = 0; index < this.multipleSelection2.length; ++index) {
          if (names2.includes(this.multipleSelection2[index]["SINIESTRO"])){
            marcados2.push(this.multipleSelection2[index]);
          }
      }

      // console.log(marcados2.length);

      if (marcados2.length > 0 ){
        this.$Progress.finish();
        this.crearNotificacion(
                  "Advertencia",
                  "Tiene seleccionado "+ marcados2.length +" casos que no se pueden pagar",
                  "error"
                );
      
      } else {
        
        if (marcados.length === 0 ){
          
          this.crearNotificacion(
                  "Advertencia",
                  "Debe seleccionar al menos 1 casos que se pueda pagar",
                  "error"
                );

        } else {  


          this.modalIndemnizar = true;
          
        }
      }

    },

    fnc_quitarvb(){
       this.modalRechazar = true;

      var filtrados2 = this.$refs.refTable2.tableData;
      const names2 = filtrados2.map(el => el.SINIESTRO);
      var marcados2 = new Array();
      
      console.log('marcado antes', marcados2);

      for (var index = 0; index < this.multipleSelection2.length; ++index) {
          if (names2.includes(this.multipleSelection2[index]["SINIESTRO"])){
            marcados2.push(this.multipleSelection2[index]);
          }
      }

      console.log('marcado de quitar vb', marcados2);


    },


    indemnizar(){
      
      this.$Progress.start();

      /* solo los marcados y filtrados */
      /* Indemnizaciones - Casos que se pueden pagar */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.SINIESTRO);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["SINIESTRO"])){
            marcados.push(this.multipleSelection[index]);
          }
      }

      
          this.modalIndemnizar = true;
        

          var siniestrosMarcados = "";
          var index = 0;
        
          for (index = 0; index < marcados.length; ++index) {
            siniestrosMarcados += marcados[index]["SINIESTRO"] + ',';
          }
        
          if (siniestrosMarcados != ""){

            siniestrosMarcados = siniestrosMarcados.slice(0, -1)
            apiIndemniza
              .indemnizar(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                siniestrosMarcados,
                this.datosFormulario.fecpago
              )
              .then(response => {
                this.$Progress.finish();
                this.crearNotificacion(
                    "Indemnizar",
                    response.data.festado.resultado.mensaje,//"Se han indemnizado todos los siniestros seleccionados.",
                    "success"
                  );
                this.buscar();
              })
              .catch(error => {
                this.$Progress.finish();
                this.crearNotificacion("Error de sistema", error, "error");
                return;
              });
          }
      
      
    },
  
    detalleBeneficiarios(siniestro){
      apiIndemniza
          .beneficiarios(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestro
          )
          .then(response => {
            this.$Progress.finish();
            this.dataBeneficiarios = response.data.res;
            this.modalBeneficiarios = true;
          })
          .catch(error => {
            this.modalBeneficiarios = false;
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    }
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
  },

  watch: {
    pagina: function (nuevo, anterior) {
      this.paginaAnterior = anterior;
    },

    data: function() {
      this.$nextTick(function() {
        console.log("paso");
        this.$refs.refTable1.$children[0].clearSelection();
        this.$refs.refTable2.$children[0].clearSelection();
    /*    var lista = this.data;
        var index = 0;
        for (index = 0; index < lista.length; ++index) {
            this.toggleSelection([lista[index]]);
        }*/
      })
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tag {
  background: #20a8d8 !important;
}
.multiselect__option--highlight:after {
  background: #20a8d8 !important;
}

.multiselect__option--highlight {
  background: #20a8d8 !important;
}
.multiselect__tags {
  border-radius: 0px !important;
  min-height: 70px !important;
}
</style>
